module.exports = __webpack_public_path__ + "img/img10.249c2533.jpg";